import { render, staticRenderFns } from "./OpenReceiptPopup.vue?vue&type=template&id=45432d59&scoped=true&"
import script from "./OpenReceiptPopup.vue?vue&type=script&lang=js&"
export * from "./OpenReceiptPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45432d59",
  null
  
)

export default component.exports